module.exports = __webpack_public_path__ + "static/media/silkycloud-pink-1.c05faca6.png";